<template>
  <header>
    <router-link to="/">
      <h2><Logo /><span>{{ $config.common.title }}</span></h2>
    </router-link>
  </header>
</template>

<script>
import Logo from '@/assets/images/decors/icons/logo_dc.svg?inline';

export default {
  name: 'Header',
  components: {
    Logo,
  },
  data() {
    return {
    };
  },
};

</script>
<style lang="stylus" scoped>
h2 {
  display: flex;
  gap: 16px
  font-size: 28px;
  font-style: normal;
  font-weight: 700;
  line-height: 28px; /* 100% */
  text-transform: uppercase;
  align-items: center;
  justify-content: flex-start;
  color: white;
  filter: drop-shadow(0px 0px 20px rgba(0, 117, 188, 1));

  span {
    width: 220px
    text-align: left;
  }
  svg {
    +mobile() {
      width: 70px;
      height: auto
    }

    path {
      stroke: white;

      /* kept for future references - Starting state */
      // stroke-dasharray: 10 6;
      // stroke-dashoffset: 0;
      // fill: rgba(255, 255, 255, 0.0);
      // animation: dash 3s linear forwards;

      /* kept for future references */
      @keyframes dash {
        0% {
          stroke-dashoffset: 300;
          stroke-dasharray: 10 40;
          fill: rgba(255, 255, 255, 0.0);
        }
        66% {
          stroke-dashoffset: 0;
          stroke-dasharray: 20 0;
          fill: rgba(255, 255, 255, 0.0);
        }
        100% {
          stroke-dashoffset: 0;
          stroke-dasharray: 20 0;
          fill: rgba(255, 255, 255, 1);
        }
      }
    }
  }
}
</style>
